import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class ChkPaymentMethodRadioPlugin implements Plugin {
  private readonly radios: NodeListOf<HTMLInputElement>;

  constructor(private readonly element: HTMLElement) {
    this.radios = element.querySelectorAll('input[type="radio"]');
  }

  init(): void {
    if (this.radios.length === 0) return;

    this.radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (radio.checked) this.showPanelFor(radio);
      });
    });

    this.syncPanelsVisibility();
  }

  private showPanelFor(activeRadio: HTMLInputElement): void {
    this.radios.forEach((radio) => {
      const targetId = radio.getAttribute("data-target");
      if (!targetId) return;

      const panel = document.getElementById(targetId);
      if (panel) {
        panel.hidden = radio !== activeRadio;
      }
    });
  }

  private syncPanelsVisibility(): void {
    const checked = Array.from(this.radios).find((radio) => radio.checked);
    if (checked) this.showPanelFor(checked);
  }
}

PluginRegistry.register(
  "chk-payment-method-radio",
  ChkPaymentMethodRadioPlugin,
);
